"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheckoutConsignmentHomeDeliveryAddressesPath = exports.getCheckoutConsignmentHomeDeliveryAddresses = void 0;
const utils_1 = require("@invivodf/utils");
const utils_2 = require("../../../utils");
const getCheckoutConsignmentHomeDeliveryAddresses = (client) => async ({ checkoutId, consignmentId }) => {
    try {
        const response = await client.get((0, exports.getCheckoutConsignmentHomeDeliveryAddressesPath)(checkoutId, consignmentId));
        return utils_1.Result.success(response.data);
    }
    catch (error) {
        if ((0, utils_2.isFunctionalApiError)(error)) {
            return utils_1.Result.failure({
                code: error.body.code,
                message: error.body.message
            });
        }
        throw error;
    }
};
exports.getCheckoutConsignmentHomeDeliveryAddresses = getCheckoutConsignmentHomeDeliveryAddresses;
const getCheckoutConsignmentHomeDeliveryAddressesPath = (checkoutId, consignmentId) => `/v2/bff/appro/checkouts/${checkoutId}/consignments/${consignmentId}/home-delivery-addresses`;
exports.getCheckoutConsignmentHomeDeliveryAddressesPath = getCheckoutConsignmentHomeDeliveryAddressesPath;
